import { createAsyncThunk } from '@reduxjs/toolkit';
import { RETRIEVE_VEHICLES } from '../../../constants/Commercial/Vehicles';
import VehicleService from '../../../../services/Commercial/VehicleService';

// eslint-disable-next-line import/prefer-default-export
export const retrieveVehicles = createAsyncThunk(RETRIEVE_VEHICLES, async (filtersProcessor) => {
	const response = await VehicleService.getVehicles(filtersProcessor);
	return response.data;
});
